module.exports = __webpack_public_path__ + "static/media/rebirth_26.a181a0e2.jpg";